export default __webpack_public_path__ + "static/website-icon-d92e1d2b75db35e34f8bbf048b4af6a2.png";